import { ExtractedEntities } from "../types";

export function pickOne<T>(list: T[]): T {
  return list[Math.floor(Math.random() * list.length)];
}

export function formatDate(date?: string): string {
  if (!date) return "nieokreślony termin";
  return date;
}

export function buildConversationScript(entities: ExtractedEntities): string {
  const openings = [
    `W dniu ${formatDate(entities.date)} odbyła się rozmowa z ${entities.employee || "pracownikiem"}.`,
    `${entities.employee || "Pracownik"} — rozmowa managerska z ${formatDate(entities.date)}.`,
    `Notatka z rozmowy: ${entities.employee || "pracownik"}, ${formatDate(entities.date)}.`,
    `Omówiono z ${entities.employee || "pracownikiem"} następujące ustalenia.`
  ];

  const closings = [
    `Ustalenia: ${entities.arrangement || "brak"}.`,
    `Podsumowując: ${entities.arrangement || "brak"}.`,
    `Do zrobienia: ${entities.arrangement || "brak"}.`,
    `Do wykonania: ${entities.arrangement || "brak"}.`
  ];

  const middle = `Temat: ${entities.topic || "ustalenia"}.`;

  return `${pickOne(openings)}\n${middle}\n${pickOne(closings)}`;
}

export function buildIncidentScript(entities: ExtractedEntities): string {
  const openings = [
    `Zgłoszono awarię ${entities.equipment || "urządzenia"} w ${entities.location || "nieokreślonej lokalizacji"}.`,
    `${entities.location || "Hala"} — awaria urządzenia ${entities.equipment || "---"} ${entities.date ? `z dnia ${formatDate(entities.date)}` : ""}.`.trim(),
    `Raport zdarzenia: ${entities.equipment || "urządzenie"}, ${entities.location || "lokalizacja"}${entities.date ? `, ${formatDate(entities.date)}` : ""}.`.trim(),
    `Do natychmiastowej interwencji: ${entities.equipment || "urządzenie"} w ${entities.location || "hali"}.`
  ];

  const closings = [
    `Objaw: ${entities.failure || "nieokreślony"}. Priorytet: ${entities.priority || "standardowy"}.`,
    `Usterka: ${entities.failure || "nieokreślona"}. Pilność: ${entities.priority || "standardowa"}.`,
    `Wada: ${entities.failure || "nieokreślona"}. Priorytet: ${entities.priority || "normalny"}.`,
    `Opis: ${entities.failure || "brak"}. Priorytet: ${entities.priority || "standardowy"}.`
  ];

  const middle = `Miejsce: ${entities.location || "nieokreślone"}.`;

  return `${pickOne(openings)}\n${middle}\n${pickOne(closings)}`;
}
